import React from 'react';
import { BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
    BringzzPageContainer,
    BringzzIcon,
    BringzzImage,
} from "@bringzz/components";

import SOFORT_IMAGE from "assets/methods/sofort.png"
import KLARNA_IMAGE from "assets/methods/klarna.png"
import GOOGLEPAY_IMAGE from "assets/methods/googlepay.png"
import APPLEPAY_IMAGE from "assets/methods/applepay.png"

const AddPaymentMethod = () => {
    const { backPress, navigate } = useNavigation();

    const handleMethodSelect = (method) => {
        switch (method) {
            case 'card':
                navigate('/payment/add/card');
                break;
            case 'sofort':
                // TODO: Implement Sofort flow
                break;
            case 'klarna':
                // TODO: Implement Klarna flow
                break;
            case 'google':
                // TODO: Implement Google Pay flow
                break;
            case 'apple':
                // TODO: Implement Apple Pay flow
                break;
            default:
                break;
        }
    };

    const PaymentOption = ({ icon, image, title, value, subtitle }) => (
        <div 
            className="flex items-center justify-between py-3 px-4 border-b cursor-pointer hover:bg-gray-50 transition-colors duration-200"
            onClick={() => handleMethodSelect(value)}
        >
            <div className="flex items-center gap-3">
                {image ? (
                    <div className="w-8 h-8 flex items-center justify-center">
                        <BringzzImage
                            className="w-auto h-5 object-contain"
                            src={image}
                        />
                    </div>
                ) : (
                    <div className="w-8 h-8 flex items-center justify-center">
                        <BringzzIcon
                            icon={icon}
                            folder="LineIcons"
                            size='24'
                            className="text-midnight-blue"
                        />
                    </div>
                )}
                <div>
                    <BringzzText tag="h3" className="font-medium text-sm">
                        {title}
                    </BringzzText>
                    {subtitle && (
                        <BringzzText className="text-xs text-gray-500">
                            {subtitle}
                        </BringzzText>
                    )}
                </div>
            </div>
            <BringzzIcon
                icon="IconChevronRight"
                folder="LineIcons"
                size="16"
                className="text-gray-400"
            />
        </div>
    );

    return (
        <BringzzPageContainer
            className="bg-white"
            header={{
                left: (
                    <BringzzIcon
                        size='22'
                        icon='IconChevronLeft'
                        folder='LineIcons'
                        className='cursor-pointer'
                        onClick={backPress}
                    />
                ),
                title: <BringzzText tag='h2'>Add Payment Method</BringzzText>
            }}
        >
            <div className='relative bg-white w-full'>
                <div className='py-4'>
                    <div className="border-t">
                        <PaymentOption
                            icon="IconCreditCard"
                            title="Credit Card"
                            subtitle="Visa, Mastercard"
                            value="card"
                        />
                        <PaymentOption
                            image={SOFORT_IMAGE}
                            title="Sofortüberweisung"
                            subtitle="Direct bank transfer"
                            value="sofort"
                        />
                        <PaymentOption
                            image={KLARNA_IMAGE}
                            title="Klarna"
                            subtitle="Pay later or in installments"
                            value="klarna"
                        />
                        <PaymentOption
                            image={GOOGLEPAY_IMAGE}
                            title="Google Pay"
                            subtitle="Fast checkout with Google Pay"
                            value="google"
                        />
                        <PaymentOption
                            image={APPLEPAY_IMAGE}
                            title="Apple Pay"
                            subtitle="Quick and secure checkout"
                            value="apple"
                        />
                    </div>
                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default AddPaymentMethod; 